import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { atxIsMobile$ } from '@epicuro-next/ataraxia/breakpoint';
import { copyLinkTooltip } from '@epicuro-next/constants/features/localization';
import { isCommercialList } from '@epicuro-next/features/engagement/list-utils';
import { List, LookBook } from '@epicuro-next/models/engagement';

@Component({
  selector: 'epc-list-header-text',
  templateUrl: './list-header-text.component.html',
  styleUrls: ['./list-header-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListHeaderTextComponent {
  public isMobile$ = atxIsMobile$;
  public copyLinkTooltip = copyLinkTooltip;

  @Input()
  public list: List;

  @Input()
  public lookBook?: LookBook;

  @Input()
  public showLookBookName: boolean;

  public get header() {
    if (this.list) return this.list.name;
    if (this.lookBook && !this.showLookBookName) return this.lookBook.title;
    return undefined;
  }

  public get isCommercial() {
    if (!this.list) return;

    return isCommercialList(this.list);
  }

  public get shareableList() {
    return this.list ?? this.lookBook?.items[0].productList;
  }
}
